// extracted by mini-css-extract-plugin
module.exports = {"description":"VenueDescription-module--description--efdd7c"};